const types = {
    SET_ORDERS: "SET_ORDERS",
    UPDATE_ORDERS: "UPDATE_ORDERS",

    SET_SHOPPING_ORDERS: "SET_SHOPPING_ORDERS",
    UPDATE_SHOPPING_ORDER: "UPDATE_SHOPPING_ORDER"
}

export default types